module.exports = __webpack_public_path__ + "assets/img/frequency.0e0d382a.svg";